import { aomGraphqlRequest } from 'core/utils/backend-service';
import { FeatureFlagAPI } from './feature-flag.api';
import { DEFAULT_FEATURE_FLAGS } from './feature-flag.constants';
import { getFeatureFlagQuery } from './feature-flag.queries';

// Feature flags drive middleware menu visibility (AOM, ADM, AMM, ...).
// They are resolved by the AOM resource-aggregation, which is the only middleware
// gateway always deployed regardless of which optional modules a customer enables.
// On failure we log a warning and fall back to DEFAULT_FEATURE_FLAGS so the failure
// is observable instead of silently hiding the entire optional menu surface.
export const getFeatureFlag = async (): Promise<FeatureFlagAPI[]> =>
    aomGraphqlRequest(getFeatureFlagQuery())
        .then((result) => result.data.features)
        .catch((error) => {
            console.error('Failed to load feature flags from AOM RA. Falling back to defaults.', error);
            return DEFAULT_FEATURE_FLAGS;
        });
